export function isNumberRegexp<T>(errorMsg: T) {
  return (value: unknown) => {
    if (typeof value !== 'string' && typeof value !== 'number') {
      return errorMsg;
    }

    const integerRegex = /^-?\d+$/;

    return value && integerRegex.test(value.toString().trim()) ? undefined : errorMsg;
  };
}
